export enum ErrorType {
    Default = 'Default',
    NotFound = 'Not Found',
    AccessDenied = 'Access Denied'
}